<template>
  <div class="watch-download">
    <div class="watch-download-buttons">
      <wptv-button
        v-tealium:click="$stats.fip.onWatchVideo(item, orderInfo)"
        :disabled="!isCompatible"
        :aria-label="isPlayOngoing ? $t('fip.accessibility.resume', {title: item.title}) : $t('fip.accessibility.watch', {title: item.title})"
        type="full"
        background="black"
        data-wptv="banniere-play_video-regarder"
        @click.native="watch()">
        {{ isPlayOngoing ? $t('fip.buttons.continueWatchLabel') : $t('fip.buttons.watchLabel') }}
      </wptv-button>
      <wptv-button
        v-if="!item.freeContent"
        v-mlv:movie="{
          id: downloadId,
          scheme: mlvUrl.schemeUrl,
          fallback: mlvModal}"
        :disabled="!isCompatible"
        :aria-label="$t('fip.accessibility.download', {title: item.title})"
        type="wired"
        background="black"
        data-wptv="banniere-telecharger">
        {{ $t('fip.buttons.downloadLabel') }}
      </wptv-button>
    </div>
    <bookmarks-button
      :item="item"
      :can-be-bookmarked="canBeBookmarked"
      class="bookmarks-button" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import _get from 'lodash/get'
import BookmarksButton from '../bookmarksButton/BookmarksButton'
import { WptvButton } from '@wptv/components/ui/button'

export default {
  name: 'WatchDownload',
  components: {
    BookmarksButton,
    WptvButton
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    orderInfo: {
      type: Object,
      required: true
    },
    canBeBookmarked: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapGetters({
      terminalModel: 'terminals/getTerminalModel',
      findPlayHistoryById: 'user/findPlayHistoryById'
    }),
    mlvUrl () {
      return this.$config.confetti.public.urls.mlv
    },
    downloadId () {
      return this.orderInfo.ticketId
    },
    isCompatible () {
      return this.item.eligibleTerminalModels.includes(this.terminalModel)
    },
    playHistory () {
      return this.findPlayHistoryById(this.item.id)
    },
    isPlayOngoing () {
      return this.playHistory && this.playHistory.watchingState === 'ONGOING'
    },
    timecode () {
      return this.playHistory?.resumeTimecode || 0
    }
  },
  methods: {
    watch () {
      this.$root.$emit('watch', {
        giftId: _get(this.orderInfo, 'giftId', null),
        videoToPlay: this.item,
        timecode: this.timecode
      })
    },
    mlvModal () {
      this.$root.$emit('download-app-modal/open')
    }
  }
}
</script>

<style lang="scss" scoped>
  .watch-download {
    display: inline-flex;
    align-items: center;
    flex-wrap: wrap;
    width: 100%;
    @include mediaQueries('width', (medium: auto));
    flex-direction: column;
    @include mediaQueries('flex-direction', (small: row));

   .watch-download-buttons {
     display: inline-flex;
     flex-direction: column;
     @include mediaQueries('flex-direction', (medium: row));
     width: 100%;
     @include mediaQueries('width', (large: auto));
     margin: 0;
     @include mediaQueries('margin', (medium: 20px 0 20px 0));

    button {
      z-index: 2;
      max-width: unset;
      width: 100%;
      @include mediaQueries('width', (medium: auto));
      margin-right: 0;
      @include mediaQueries('margin-right', (medium: 30px));

      &:first-child {
        @include mediaQueries('margin-right', (medium: 30px));
        margin-bottom: 15px;
        @include mediaQueries('margin-bottom', (medium: 0));
        margin-top: 15px;
        @include mediaQueries('margin-top', (medium: 0));
      }
    }
  }
}
</style>
